import { PaymentType } from '../../enums/payment-type.enum'

const PaymentOptions = [
  {
    label: 'Crédito',
    value: PaymentType.CREDIT,
  },
  /* {
    label: 'Débito',
    value: PaymentType.DEBIT, this will be implemented in the future
  }, */
  {
    label: 'Boleto',
    value: PaymentType.BOLETO,
  },
]

export default PaymentOptions
